import React from 'react'

interface CircleChevronDownProps {
  circleClassName?: string
  pathClassName?: string
  isOpen?: boolean
}

export const CircleChevronDown = ({
  circleClassName = 'dark:fill-gray-600',
  pathClassName = 'dark:stroke-gray-300',
  isOpen = false,
}: CircleChevronDownProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="transition-transform duration-200 ease-in-out"
      style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
    >
      <g clipPath="url(#clip0_2628_18782)">
        <circle cx="10" cy="10" r="7.5" fill="#EBEBEB" className={circleClassName} />
        <path
          d="M12.5 9.16602L10 11.666L7.5 9.16602"
          stroke="#40424A"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={pathClassName}
        />
      </g>
      <defs>
        <clipPath id="clip0_2628_18782">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
